module.exports = __webpack_public_path__ + "static/media/edit-icon.9bd115c5.svg";